import { useMemo } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from '@/lib/auth';
import { createQueryClient } from '@/lib/queryClient';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AppLayout } from '@/components/Layout/AppLayout';
import { SignIn } from '@/pages/auth/SignIn';
import { Messages } from '@/pages/Messages';
import { Threads } from '@/pages/Threads';
import { Acknowledgements } from '@/pages/Acknowledgements';
import { Settings } from '@/pages/Settings';
import { Medbin } from '@/pages/Medbin';

export default function App() {
  const queryClient = useMemo(() => createQueryClient(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/messages" replace />} />
            <Route path="/sign-in" element={<SignIn />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/messages" element={<Messages />} />
              <Route path="/threads" element={<Threads />} />
              <Route path="/acknowledgements" element={<Acknowledgements />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/medbin" element={<Medbin />} />
            </Route>

            <Route path="*" element={<Navigate to="/messages" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
